export interface TrafficLightComponentModel {
    color: TrafficLightColorComponentModel;
    label: string;
    description: string;
}

export enum TrafficLightColorComponentModel {
    None,
    Green,
    Yellow,
    Red,
}
